import { PropsWithChildren } from 'react'
import styles from './ArticleValve.module.scss'

const ArticleValve = ({ children }: PropsWithChildren) => {
  return <section className={styles['article-valve']}>{children}</section>
}

export default ArticleValve
